export const REQUEST_REFINEMENT_EVENT = 'do-chat:request-refinement'

/**
 * Make a selected excerpt available to the active ask bar without coupling the
 * response/document surface to a particular chat layout.
 * @param {string | { text: string, source?: 'assistant_response' | 'artifact', sourceResponseText?: string, artifactId?: string, artifactName?: string, artifactKind?: string }} selection
 */
export function requestRefinement(selection) {
  const details = typeof selection === 'string' ? { text: selection } : (selection ?? {})
  const text = String(details.text ?? '').trim()
  if (!text || typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent(REQUEST_REFINEMENT_EVENT, {
      detail: {
        text,
        source: details.source === 'artifact' ? 'artifact' : 'assistant_response',
        ...(details.sourceResponseText ? { sourceResponseText: String(details.sourceResponseText) } : {}),
        ...(details.artifactId ? { artifactId: String(details.artifactId) } : {}),
        ...(details.artifactName ? { artifactName: String(details.artifactName) } : {}),
        ...(details.artifactKind ? { artifactKind: String(details.artifactKind) } : {}),
      },
    }),
  )
}
